import { Injectable, Injector, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from "@angular/common";

declare const google: any;
let $_: any;

//const API_KEY: string = 'AIzaSyDQNfE-nSkQjWTDKmy3RiAiyWiB0jd7RmY';

@Injectable()
export class GoogleService {

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {

        $_ = this;

        /*if (isPlatformBrowser($_.platformId)) {

            google.load("maps", "3", {

                nocss: true,
                other_params: "key=" + API_KEY,
                callback: () => {
                }
            });
        }*/
    }

    public run_map_function(callback: Function) {

        if (isPlatformBrowser($_.platformId)) {

            if (google && google.maps && typeof google.maps.Map === "function") {

                callback();

            } else {

                setTimeout(() => {

                    $_.run_map_function(callback);

                }, 10);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/google/google.service.ts